import castArray from 'lodash/fp/castArray';
import flow from 'lodash/fp/flow';
import filter from 'lodash/fp/filter';
import get from 'lodash/fp/get';
import getOr from 'lodash/fp/getOr';
import join from 'lodash/fp/join';
import keys from 'lodash/fp/keys';
import map from 'lodash/fp/map';
import mapKeys from 'lodash/fp/mapKeys';
import pickBy from 'lodash/fp/pickBy';
import replace from 'lodash/fp/replace';
import { getTicketCountsBasedOnType } from '../../utils';

export default function getEnhancementInformation({ productId, booking, enhancementAssetType }) {
	let booking_currency = '';
	let enhancement_quantity = [];
	let enhancement_category = [];
	let enhancement_subcategory = [];
	let enhancement_type = [];
	let enhancement_name = [];
	let enhancement_price = [];
	let enhancement_pricing_type = [];
	let enhancement_asset_types = [];
	let enhancement_merch_a = [];

	// This variable provides additional required details for an enhancement, including number of adults,
	// number of children, and time of day.
	// For each enhancement, a string should be passed containing key-value pairs of all relevant details.
	// The key-value pairs should be delimited using a carat ("^").
	let enhancement_details = [];
	booking_currency = getOr('N/A', ['price', 'total', 'cash', 'usdCurrencyCode'])(booking);
	function handlePushingEnhancementInfoToArray(eventProduct) {
		const {
			code,
			name,
			merchantGroupType,
			merchantGroupCategory,
			merchantGroupSubCategory,
			price,
			timeOfDay = '',
			numAdults = '',
			numChildren = '',
			productRank = 'standard',
		} = eventProduct;
		const duration = flow(
			get(['price', 'priceName']),
			replace(/\s*(minutes|minute|mins|min)/, '')
		)(eventProduct);

		flow(
			get(['ticketBreakdown', 'ticketTypes']),
			map(ticketType => {
				enhancement_name.push(name);
				enhancement_merch_a.push(productRank);
				enhancement_quantity.push(ticketType?.ticketCount?.toString());

				if (merchantGroupType) {
					enhancement_type.push(merchantGroupType);
				}

				if (merchantGroupCategory) {
					enhancement_category.push(merchantGroupCategory);
				}

				if (merchantGroupSubCategory) {
					enhancement_subcategory.push(merchantGroupSubCategory);
				}

				if (ticketType?.usdAmount) {
					enhancement_price.push(`${ticketType?.usdAmount / ticketType?.ticketCount}`);
					booking_currency = `${ticketType?.usdCurrencyCode}`;
				} else {
					enhancement_price.push(`${ticketType?.amount / ticketType?.ticketCount}`);
				}

				const isComplimentary = ticketType?.amount === 0;
				enhancement_pricing_type.push(isComplimentary ? 'Complimentary' : 'Paid');
				if (enhancementAssetType) {
					enhancement_asset_types.push(enhancementAssetType);
				}

				const enhancementDetails = {
					...getTicketCountsBasedOnType(ticketType, numAdults, numChildren),
					time: timeOfDay,
					minutes: duration,
				};

				enhancement_details.push(
					flow(
						pickBy(Boolean),
						mapKeys(key => `${key}:${enhancementDetails[key]}`),
						keys,
						join('^')
					)(enhancementDetails)
				);
			})
		)(price);
	}

	const eventProducts = getOr([], ['eventProducts'])(booking);

	// DEV NOTE: If given productId as argument, only return enhancement information for that productId,
	// otherwise function will return information for all enhancements in booking.
	let productIdsArray = productId
		? castArray(Number(productId))
		: map(get('productId'))(eventProducts);

	flow(
		filter(eventProduct => productIdsArray.includes(eventProduct.productId)),
		map(handlePushingEnhancementInfoToArray)
	)(eventProducts);

	return {
		booking_currency,
		enhancement_quantity,
		enhancement_category,
		enhancement_subcategory,
		enhancement_type,
		enhancement_name,
		enhancement_price,
		enhancement_details,
		enhancement_pricing_type,
		...(enhancement_asset_types.length ? { enhancement_asset_types } : {}),
		enhancement_merch_a,
	};
}
